<template>
    <div class="animated fadeIn">
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <form v-else @submit="ValidarForm">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card">
              <header class="card-header">
                <strong class="align-self-center">Nova Densidade Carbono</strong>
              </header>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <small>Campos com * são de preenchimento obrigatório</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                      <label for>* Nome Comum</label>
                      <input
                        v-model="viewModel.commonName"
                        class="form-control"
                        type="text"
                        placeholder="Digite o nome comum"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                      <label for>* Nome Científico</label>
                      <input
                        v-model="viewModel.scientificName"
                        class="form-control"
                        type="text"
                        placeholder="Digite o nome científico"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group">
                      <label for>* Densidade da Madeira (g/cm³)</label>
                      <input
                        v-model="viewModel.density"
                        class="form-control"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Digite o número da densidade"
                        required
                      />
                    </div>
                  </div>


                </div>
                <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="">Observações</label>
                    <b-form-textarea
                      v-model="viewModel.obs"
                      rows="4"
                      max-rows="12"
                      placeholder="Digite observações"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              </div>
              
              <div class="btn-toolbar mb-3 ml-3" role="toolbar">
                <div class="btn-group" role="group">
                  <button class="btn btn-success mr-2" type="submit">
                    Salvar
                  </button>
                </div>
                <div class="btn-group" role="group">
                  <button
                    class="btn btn-secondary"
                    type="reset"
                    @click="$router.go(-1)"
                  >
                    Voltar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import RotateSquare from "../../components/RotateSquare";
  import CarbonService from "../../servico/CarbonService";
  
  export default {
    name: "NewCarbon",
    components: {
      RotateSquare
    },
    data() {
      return {
        loading: false,
        viewModel: {
          id: this.$store.getters.emptyGuid,
          commonName: "",
          scientificName: "",
          density: "",
          obs: ""
        }
      };
    },
    created() {
      let id = this.$route.params.id;
      if (id) this.Obter(id);
    },
    methods: {
      ValidarForm(evt) {
        evt.preventDefault();
        if (this.viewModel.id !== this.$store.getters.emptyGuid) this.Editar();
        else this.Novo();
      },

      Obter(id) {
        this.loading = true;
  
        CarbonService.Get(id)
          .then((resposta) => {
            this.loading = false;
            this.viewModel = resposta.data;
          })
          .catch((erro) => {
            this.loading = false;
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 5000
            });
          });
      },
      Novo() {
        this.loading = false;
  
        CarbonService.New(this.viewModel)
          .then(() => {
            this.loading = false;
            this.$router.go(-1);
            this.$notify({
              data: ["Densidade cadastrado com sucesso."],
              type: "success",
              duration: 5000
            });
          })
          .catch((erro) => {
            this.loading = false;
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 5000
            });
          });
      },
      Editar() {
        this.loading = false;
  
        CarbonService.Edit(this.viewModel)
          .then(() => {
            this.loading = false;
            this.$router.go(-1);
            this.$notify({
              data: ["Densidade editado com sucesso."],
              type: "success",
              duration: 5000
            });
          })
          .catch((erro) => {
            this.loading = false;
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 5000
            });
          });
      }
    }
  };
  </script>
  